module.exports = __webpack_public_path__ + "img/26.00665cc6.jpg";